import React from "react";

export const BtnBi = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      className="absolute bg-red-400 top-[8px] left-[15px] rounded-lg shadow-lg text-sm px-3 py-2 font-bold text-white btn-hide"
      onClick={() => {
        onClick && onClick();
      }}
    >
      Regresar a Sondeos
    </button>
  );
};
